import styled from 'styled-components';

export const ListViewContainer = styled.div`
  width: 100%;
  min-height: 420px;
  > div > div > div {
    overflow-x: visible;
  }
  padding-bottom: 24px;
`;

export const CustomHyperLink = styled.a`
  color: ${(props) => props.theme.colors.greys.darkest};
  &:hover {
    color: ${(props) => props.theme.colors.greys.darkest};
  }
  cursor: pointer;
`;
